import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isEmpty, get, find, size } from 'lodash';
import querySearchToObject from 'utils/query-search-to-object';
import { selectIsVisible } from 'reducers/epg-widget/selectors';
import { getIsLifecellFlag } from 'reducers/profile/selectors';
import { getChannelsDataSelector, getIsLoadingSelector } from 'reducers/channels/selectors';
import useUpdateChannelsProgress from './useUpdateChannelsProgress';
import EPGWidget from './EPGWidget';
import useLoadEPGData from './useLoadEPGData';

const parseChannelId = (pathname = '') => Number(get(pathname.match(/channel\/(\d+)/), [1]));
const parseProgramStartTime = (pathname = '') => get(pathname.match(/channel\/\d+\/(\S+)/), [1]);

export const EPGWidgetContainer = () => {
  const { location } = useHistory();
  const isVisible = useSelector(selectIsVisible);
  const isLoading = useSelector(getIsLoadingSelector);
  const isLifecellUser = useSelector(getIsLifecellFlag);
  const channels = useSelector(getChannelsDataSelector);
  const categories = useLoadEPGData();

  const activeCategoryId = useMemo(() => {
    let id = Number(querySearchToObject(location.search).activeCategoryId);
    // канал можно удалить из избранного в плеере и тогда при открытии EPG виджета все ломается.
    // Если текущая категория пустая, то по дефолту ставим категорию 0 - All Channels
    const chosenCategory = find(categories, { id });
    if (chosenCategory && size(chosenCategory.channelIds) === 0) {
      id = 0;
    }
    return id;
  }, [categories, location]);
  const currentPlayingChannelId = useMemo(() => parseChannelId(location.pathname), [location]);
  const currentPlayingProgramStartTime = useMemo(() => parseProgramStartTime(location.pathname), [location]);

  const activeChannel = find(channels, { id: currentPlayingChannelId });

  const currentPlayingProgramId = useMemo(() => {
    if (!activeChannel) return null;

    const program = find(activeChannel.epg, { startTime: currentPlayingProgramStartTime });
    return get(program, ['id'], null);
  }, [activeChannel, currentPlayingProgramStartTime]);

  useUpdateChannelsProgress(channels, !!currentPlayingChannelId);

  if (isEmpty(categories) || !isVisible || isLoading) return null;

  return (
    <EPGWidget
      channels={channels}
      categories={categories}
      currentActiveCategoryId={activeCategoryId}
      currentPlayingChannelId={currentPlayingChannelId}
      currentPlayingProgramId={currentPlayingProgramId}
      isLifecellUser={isLifecellUser}
    />
  );
};

export default EPGWidgetContainer;
